__turbopack_context__.v({
  "container": "AboutUsImageAndText-module__5fw8bq__container",
  "containerImageOnRight": "AboutUsImageAndText-module__5fw8bq__containerImageOnRight",
  "headerContainer": "AboutUsImageAndText-module__5fw8bq__headerContainer",
  "image": "AboutUsImageAndText-module__5fw8bq__image",
  "imageContainer": "AboutUsImageAndText-module__5fw8bq__imageContainer",
  "imageContainerWithMultipleImages": "AboutUsImageAndText-module__5fw8bq__imageContainerWithMultipleImages",
  "imageFocus__bottom": "AboutUsImageAndText-module__5fw8bq__imageFocus__bottom",
  "imageFocus__center": "AboutUsImageAndText-module__5fw8bq__imageFocus__center",
  "imageFocus__top": "AboutUsImageAndText-module__5fw8bq__imageFocus__top",
  "imageOverlay": "AboutUsImageAndText-module__5fw8bq__imageOverlay",
  "imageSize__200": "AboutUsImageAndText-module__5fw8bq__imageSize__200",
  "noMinHeight": "AboutUsImageAndText-module__5fw8bq__noMinHeight",
  "objectFitContain": "AboutUsImageAndText-module__5fw8bq__objectFitContain",
  "textContainer": "AboutUsImageAndText-module__5fw8bq__textContainer",
  "video": "AboutUsImageAndText-module__5fw8bq__video",
  "videoContainer": "AboutUsImageAndText-module__5fw8bq__videoContainer",
});
